<template>
  <div>
    <div class="row">
      <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
        <div class="card">
          <h5 class="card-header">Exam Details</h5>
          <div class="card-body">
            <div class="row">
              <div class="col-md-12 ">
                <table style="width: 100%" class="table table-borderless">
                  <tr>
                    <td style=" border-right: 2px solid #f0f6ff !important">Title</td>
                    <td>{{examDescription.Title}}</td>
                  </tr>
                  <tr>
                    <td style=" border-right: 2px solid #f0f6ff !important">Course</td>
                    <td>{{examDescription.Course}}</td>
                  </tr>
                  <tr>
                    <td style=" border-right: 2px solid #f0f6ff !important">Date</td>
                    <td>{{examDescription.ExamDate}}</td>
                  </tr>
                  <tr>
                    <td style=" border-right: 2px solid #f0f6ff !important">Timings</td>
                    <td>{{examDescription.StartTime}} - {{examDescription.EndTime}}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div class="card" v-if="status == 'started'">
          <h6 class="card-header">Questions Summary</h6>
          <div class="card-body">
            <div class="row">
              <div class="col-md-12 col-xs-12 col-lg-12 text-center">
                <span :class="getcolour(item.Status)" v-for="(item, ind) in summary" style="margin: 3px 3px 3px 3px">{{ind+1}}</span>
              </div>
              <div class="col-md-12 text-center">
                <hr />
                <span class="badge badge-success text-sm" style="margin: 3px 3px 3px 3px">Attemped</span>
                <span class="badge badge-warning text-sm" style="margin: 3px 3px 3px 3px">Skiped</span>
                <span class="badge badge-dark text-sm" style="margin: 3px 3px 3px 3px">Remaining</span>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12">
        <div class="row">
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12" v-if="status != 'started'">
            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-12 text-center">
                    <h2>{{msg}}</h2>
                    <h1 style="font-size: 65px;">
                      <span style="min-width: 85px" class="badge badge-light" id="hh">00</span>:<span style="min-width: 85px" class="badge badge-light" id="mm">00</span>:<span style="min-width: 85px" class="badge badge-light" id="ss">00</span>
                    </h1>
                    <button v-if="status == 'started'" class="btn btn-lg btn-primary" type="button" v-on:click="startExam()">Start Exam</button>
                    <p>Your exam will be automatically started on time</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12" v-if="status == 'started'">
            <div class="card">
              <h6 class="card-header">
                Question <b>{{questionNo}}</b> of <b>{{totalQuestions}}</b>
                <span class="float-right">Time Left <strong class="text-danger text-bold " id="showtime"></strong> </span>
              </h6>
              <div class="card-body">
                <div class="row">
                  <div class="col-md-12">
                    <div class="table-responsive">
                      <table style="width:100%; font-size: 12px;">
                        <tbody>
                          <tr>
                            <td>
                              <h6 style="font-weight:bolder">{{question.Title}}</h6>
                              <img width="50%" v-if="question.Attachment" :src="question.Attachment" />
                              <span> <br /> {{question.Description}}</span>
                            </td>
                          </tr>
                          <tr>
                            <td style="text-align: left">

                              <table class="table table-bordered table-sm" style="font-size: 14px; width:100%; font-size: 12px;">
                                <tr v-for="(item, ind) in question.Options">
                                  <th style="vertical-align: central; text-align: center" class="bg-gray-light" width="60px;">
                                    <div class="custom-control custom-radio">
                                      <input class="custom-control-input" type="radio" :id="ind" name="customRadio" v-model="question.SelectedOption" :value="item.Letter">
                                      <label :for="ind" style=" padding-top: 1.5px;" class="custom-control-label">{{item.Letter}}</label>
                                    </div>
                                  </th>
                                  <td style="vertical-align: central; padding-top: 6.5px;">
                                    {{item.Title}}
                                    <img style="max-height: 100px;" v-if="item.Attachment" :src="item.Attachment" />
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer bg-light">
                <div class="row">
                  <div class="col-md-12 ">
                    <div style="text-align:center">
                      <button v-if="questionNo != totalQuestions" style="width: 80px !important;" class="btn btn-success btn-rounded submit btn-sm" v-on:click="loadNextQuestion('Attempted')">Next</button>
                      <button v-if="questionNo != totalQuestions" style="width: 80px !important;" class="btn btn-warning clear-form btn-sm btn-rounded btn-outline" v-on:click="loadNextQuestion('Skipped')">Skip</button>
                      <button v-if="questionNo == totalQuestions" style="width: 130px !important;" class="btn btn-success clear-form btn-sm btn-rounded btn-outline" v-on:click="loadNextQuestion('Attempted')">Finish</button>
                      <button v-if="questionNo == totalQuestions" style="width: 130px !important;" class="btn btn-warning clear-form btn-sm btn-rounded btn-outline" v-on:click="loadNextQuestion('Skipped')">Skip And Finish</button>
                      <button v-if="questionNo != totalQuestions" class="btn btn-primary btn-rounded btn-sm" style="width: 80px !important;" data-toggle="modal" data-target="#myModalFinish">Finish</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <!-- Modal -->
    <div id="myModal" class="modal fade" role="dialog">
      <div class="modal-dialog modal-xl">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header bg-lightblue ">
            <h4 class="modal-title">Instructions</h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12 ">
                <strong>How to Attempt MCQs:</strong>
                <ol>
                  <li>Exam is of {{totalMinutes}} minutes, duration having {{totalQuestions}} MCQs questions . Students are required to attempt all MCQs in given time.</li>
                  <li>Exam will be submitted automatically after the given time.</li>
                  <li>You can skip the question or attempt the question.</li>
                  <li>Student will be given 4 options for each question.</li>
                </ol>

                <strong>What if Paper / Exam Remains Incomplete due to any technical reason:</strong>
                <ol>
                  <li>If any student gets stuck due to electricity and could not login at the time of examinations, he will be required to contact immediately to the concerned campus mentioning his inability / hardship.</li>
                  <li>If students, session / examinations terminates due to any technical reason, he will be allowed to login again on resumption of his internet / electricity only if it happens with in examinations allotted time and his examination will resume from where it was terminated.</li>
                </ol>
              </div>

            </div>
          </div>
          <div class="modal-footer text-left">
            <!--@*<div class="form-check ">
              <input type="checkbox" class="form-check-input" id="exampleCheck1" v-model="agree">
              <label class="form-check-label" for="exampleCheck1">I have read the instructions</label>
            </div>*@-->
            <button type="button" class="btn btn-success btn-sm" data-dismiss="modal">Continue to Exam</button>
          </div>
        </div>

      </div>
    </div>

    <div id="myModalFinish" class="modal fade" role="dialog">
      <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header bg-lightblue ">
            <h4 class="modal-title">Warning</h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12 text-center">
                <h3 class="text-danger"> <i class="fa fa-warning"></i> Are you sure you want to finish your exam ?</h3>
              </div>
            </div>
          </div>
          <div class="modal-footer text-left">
            <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button>
            <button type="button" class="btn btn-success btn-sm" v-on:click="endExam()">Finish Exam</button>
          </div>
        </div>

      </div>
    </div>
  </div>


</template>

<script>
  import axios from 'axios';
  export default {
    name: 'result',
    data() {
      return {
        submit: 'false',
        hour: '00',
        min: '00',
        sec: '01',
        examDescription: {
          Title: '',
          EndTime: '',
          Session: '',
          Course: ''
        },
        examID: 0,
        exam: '',
        status: '',
        msg: '',
        code: '',
        totalMinutes: '',
        questionNo: 1,
        totalQuestions: 0,
        question: { ExamAttempID: 0, Title: '', Options: [], SelectedOption: '' },
        summary: [],
        agree: false,

        detail: {
          Start: '',
          End: '',
          Session: '',
          Course: ''
        },
      }
    },

    mounted: function () {
      this.loadStatus();
    },

    methods: {

      loadStatus() {

        startReq();

        const urlParams = new URLSearchParams(window.location.search);

        if (urlParams) {

          this.examID = Number(urlParams.get('id'));

          var uri = window.location.toString();

          //if (uri.indexOf("?") > 0) {
          //    var clean_uri = uri.substring(0, uri.indexOf("?"));
          //    window.history.replaceState({}, document.title, clean_uri);
          //}

          var vm = this;
          axios.post('/api/PortalApi/loadExamStatus?id=' + vm.examID)
            .then(function (res) {
              if (!res.data.status) {
                window.location.href = "../Home/Index";
              }
              vm.code = res.data.code;
              vm.status = res.data.status;
              vm.examDescription = res.data.ex;
              if (vm.examDescription.Status == "Submitted") {
                window.location.href = "../Home/Index";
                return;
              }
              if (vm.status == 'upcoming') {
                vm.msg = "Be prepared! Your exam will be started soon";
                endReq();
                vm.upcomingExam();
              }
              else if (vm.status == 'started') {
                vm.msg = "Hurry Up! Your exam is started press start exam button to continue";
                vm.startExam();
              }
              else {
                vm.msg = "You are late you missed your exam";
              }
            })
            .catch(function (error) {
              console.log(error);
            });
        }
        else
          window.location.href = "../Home/Index";
      },

      startExam() {
        var vm = this;
        startReq();
        axios.post('/api/PortalApi/startExam?id=' + vm.examID)
          .then(function (res) {
            if (res.data.status) {
              if (!res.data.question) {
                window.location.href = "../Home/Index";
                return;
              }

              $('#myModal').modal({ backdrop: 'static' });
              vm.totalMinutes = res.data.minutes;
              vm.questionNo = res.data.questionNo;
              vm.totalQuestions = res.data.totalQuestions;
              vm.question = res.data.question;
              vm.summary = res.data.summary;
              vm.detail = res.data.examDetail;
              endReq();
            }
            else {
              window.location.href = "../Home/Index";
              return;
            }

            vm.startCountDown();
          })
          .catch(function (error) {
            console.log(error);
          });
      },

      loadNextQuestion(status) {

        var vm = this;

        if (status == 'Attempted' && !vm.question.SelectedOption) {
          toastr.info("Please select an option", "Info");
          return;
        }

        vm.question.Status = status;
        startReq();
        axios.post('/api/PortalApi/loadNextQuestion', {
          question: vm.question
        })
          .then(function (res) {
            if (res.data.status) {
              if (!res.data.question) {
                toastr.success("Exam submitted successfully", "Done!");
                setTimeout(function () {
                  window.location.href = "../Home/Index";
                }, 1200);
                return;
              }
              vm.question = res.data.question;
              vm.summary = res.data.summary;
              vm.questionNo++;
              endReq();
            }
            else {
              toastr.error(res.data.msg);
              window.location.href = res.data.url;
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      },

      getcolour(status) {
        if (status == "Attempted") {
          return "badge badge-circle badge-success";
        }
        else if (status == "Skipped") {
          return "badge badge-circle badge-warning";
        }
        else {
          return "badge badge-circle badge-dark";
        }
      },

      cancel() {
        window.location.href = '../Home/Index';
      },

      startCountDown() {
        var start = this.detail.Start.replace('/Date(', '');
        start = start.replace(')/', '');

        var end = this.detail.End.replace('/Date(', '');
        end = end.replace(')/', '');

        var startTime = new Date(start).getTime();
        var endTime = new Date(end).getTime();

        var x = setInterval(function () {
          var now = new Date().getTime();

          var distance = endTime - now;

          var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          var seconds = Math.floor((distance % (1000 * 60)) / 1000);

          document.getElementById("showtime").innerHTML = hours.toString().padStart(2, '0') + ":"
            + minutes.toString().padStart(2, '0') + ":" + seconds.toString().padStart(2, '0');

          if (distance < 0) {
            clearInterval(x);
            this.endExam();
          }
        }, 1000);
      },

      upcomingExam() {
        var start = this.examDescription.Start.replace('/Date(', '');
        start = start.replace(')/', '');

        var startTime = new Date(start).getTime();
        console.log(startTime);

        var x = setInterval(function () {
          var now = new Date().getTime();

          var distance = startTime - now;

          var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          var seconds = Math.floor((distance % (1000 * 60)) / 1000);

          document.getElementById("hh").innerHTML = hours.toString().padStart(2, '0');
          document.getElementById("mm").innerHTML = minutes.toString().padStart(2, '0');
          document.getElementById("ss").innerHTML = seconds.toString().padStart(2, '0');
          console.log(hours);
          console.log(minutes);
          console.log(seconds);
          if (hours == 0 && minutes == 0 && seconds == 0) {
            //clearInterval(x);
            this.status = 'started';
            this.msg = 'Hurry Up! Start your exam now.';
            this.startExam();
          }
        }, 1000);
      },

      endExam() {
        var vm = this;
        vm.question.Status = status;
        startReq();
        axios.post('/api/PortalApi/endExam?id=' + vm.examID)
          .then(function (res) {
            if (res.data.status) {
              toastr.success("Exam submitted successfully", "Done!");
              setTimeout(function () {
                window.location.href = "../Home";
              }, 1000);
              return;
            }
            else {
              alert(res.data.msg);
              window.location.href = "../Home";
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    }
  }
</script>


<style>
  #showtime {
    font-weight: bold;
  }

  .badge.badge-circle {
    border-radius: 100%;
    width: 33px;
    height: 33px;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.7;
    padding: 4px 5px;
    vertical-align: baseline;
  }
</style>



// WEBPACK FOOTER //
// src/components/school/LMS/examForm.vue